import styled from 'styled-components';

const BlogIndividualStyle = styled.div`
	--mainWrapMarginTop: var(--sp10x);
	--blogIndividualMaxWidth: var(--sp143x);
	--dateAuthorWrapMarginTop: var(--sp6x);

	--shareWrapLeftSize: 110%;

	margin-top: var(--mainWrapMarginTop);

	.blog-individual-container {
		max-width: var(--blogIndividualMaxWidth);
		margin-top: var(--mainWrapMarginTop);

		.date-author-wrap {
			display: flex;
			justify-content: space-between;
			margin-top: var(--dateAuthorWrapMarginTop);

			.read-time-wrap {
				display: flex;
				align-items: center;

				.icon-time {
					margin-right: var(--sp1-5x);
				}
			}
		}

		.content-wrap {
			position: relative;
			margin-top: calc(var(--dateAuthorWrapMarginTop) - var(--sp1x));

			.share-wrap {
				position: absolute;
				top: 0;
				left: var(--shareWrapLeftSize);
				height: 100%;

				.blog-share {
					position: sticky;
					top: var(--sp4x);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--mainWrapMarginTop: var(--sp9x);
		--blogIndividualMaxWidth: var(--sp119x);
		--dateAuthorWrapMarginTop: var(--sp5x);

		--shareWrapLeftSize: 105%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--mainWrapMarginTop: var(--sp9x);
		--blogIndividualMaxWidth: var(--sp104x);
		--dateAuthorWrapMarginTop: var(--sp5x);

		--shareWrapLeftSize: 105%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--mainWrapMarginTop: var(--sp7x);
		--blogIndividualMaxWidth: var(--sp83x);
		--dateAuthorWrapMarginTop: var(--sp4x);

		--shareWrapLeftSize: 105%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--mainWrapMarginTop: var(--sp7x);
		--blogIndividualMaxWidth: var(--sp62x);
		--dateAuthorWrapMarginTop: var(--sp3x);

		--shareWrapLeftSize: 105%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--mainWrapMarginTop: var(--sp6x);
		--blogIndividualMaxWidth: calc(100% - var(--contPaddingLR) * 2);
		--dateAuthorWrapMarginTop: var(--sp3x);

		--shareWrapLeftSize: unset;

		.date-author-wrap {
			flex-direction: column;

			.read-time-wrap {
				margin-bottom: var(--sp2x);
			}
		}

		.blog-individual-container {
			.content-wrap {
				.share-wrap {
					position: unset;

					.blog-share {
						margin-top: var(--sp3x);
					}
				}
			}
		}
	}
`;

export default BlogIndividualStyle;
